module.exports = __webpack_public_path__ + "static/media/rsStencilWhite.505e8b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press/rsStencilWhite.png
// module id = 579
// module chunks = 0